import React from 'react';
import Notice from '@src/components/Organism/Notice';
import styled from 'styled-components';
const NoticeTemplate = () => {
  return (
    <>
      <Container>
        <Notice />
      </Container>
    </>
  );
};

/* 새 공지 디자인은 리스트 카드가 자체 배경/보더를 가지므로 래퍼는 투명하게 둔다. */
const Container = styled.div`
  height: 100%;
`;

export default NoticeTemplate;
